import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Form, Button } from '@openedx/paragon';

import AlertMessage from '../../generic/alert-message';
import { copyIblCourseMetadataQuery } from '../data/thunks';

const MetadataCopySection = ({ courseId }) => {
  const dispatch = useDispatch();
  const [sourceCourseId, setSourceCourseId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleCopy = async () => {
    if (!sourceCourseId.trim()) { return; }
    setIsLoading(true);
    setMessage(null);
    const result = await dispatch(copyIblCourseMetadataQuery(sourceCourseId.trim(), courseId));
    setIsLoading(false);
    if (result?.success) {
      setIsSuccess(true);
      setMessage(result.message || 'Metadata copied successfully.');
      setTimeout(() => window.location.reload(), 2000);
    } else {
      setIsSuccess(false);
      setMessage(result?.error || 'Failed to copy metadata.');
    }
  };

  return (
    <div className="course-metadata-copy mt-4">
      <Form.Group className="form-group-custom">
        <Form.Label>Copy Metadata from Another Course</Form.Label>
        <Form.Control
          value={sourceCourseId}
          placeholder="course-v1:ORG+COURSE+RUN"
          onChange={(e) => setSourceCourseId(e.target.value)}
          disabled={isLoading}
        />
        <Form.Control.Feedback>
          Enter the full course key of the source course. All metadata will be copied to this course.
        </Form.Control.Feedback>
      </Form.Group>
      <Button
        variant="primary"
        onClick={handleCopy}
        disabled={isLoading || !sourceCourseId.trim()}
      >
        {isLoading ? 'Copying...' : 'Copy Metadata'}
      </Button>
      {message && (
        <AlertMessage
          show
          className="mt-3"
          variant={isSuccess ? 'success' : 'danger'}
          title={message}
        />
      )}
    </div>
  );
};

MetadataCopySection.propTypes = {
  courseId: PropTypes.string.isRequired,
};

export default MetadataCopySection;
